<template>
  <el-drawer :visible.sync="visible" :size="isMobile ? '100%' : '13.9vw'" :modal="false" :withHeader="false" direction="btt" custom-class="thumbWrap" :style="isMobile && { height: '101%' }">
    <!-- 移动端 -->
    <div v-if="isMobile" class="mobileWrap">
      <div class="mobileTitle">
        <div class="mobileTitleText">缩略图</div>
        <div class="mobileClose" @click="closeMe"></div>
      </div>
      <div class="mobileContent">
        <div v-for="(page, index) in pages" :class="['pageWrap', curPageIndex === index && 'active']" :key="index" @click="choosePage(index)">
          <div class="image">
            <div v-if="longPress === 0 && isMobile" class="img-shar"></div>
            <img :class="{ 'no-touch': longPress === 0 }" :src="page.url" alt="image" />
          </div>
          <div class="name">{{ index + 1 }}</div>
        </div>
      </div>
    </div>
    <!-- pc端 -->
    <div v-else class="drawerWrap" v-CustomScroll="[toLeftRightPage.bind(null, 'left'), toLeftRightPage.bind(null, 'right')]">
      <div class="pager pagerLeft" @click="toLeftRightPage('left')"></div>
      <div class="content">
        <div
          class="innerScroll"
          :style="{
            transform: `translateX(${curTranslateX}px)`
          }"
        >
          <div :class="['contentItem', currentPageNum === item.name && 'active']" v-for="(item, pcIndex) in pagesForPc" @click="choosePagePc(item)" :key="pcIndex">
            <div :class="['itemImage', item.imgUrl.length < 2 && 'single']">
              <img v-for="(imgItem, imgI) in item.imgUrl" :src="item.imgUrl[imgI]" :key="imgI" alt="image" />
            </div>
            <div class="itemName">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="pager pagerRight" @click="toLeftRightPage('right')"></div>
      <div class="close" @click="closeMe"></div>
    </div>
  </el-drawer>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import turnBookMixin from '../turnBookMixin'
export default {
  mixins: [turnBookMixin],
  data() {
    return {
      pageMessage: '', // 用于 turnBookMixin 中的翻书页码
      visible: false, // 是否显示本组件
      curPageIndex: 0, // 当前选中的页码索引（从0开始）
      // turnBookMixin中的currentPageNum为pc端的当前页码
      curTranslateX: 0 // 记录翻页所用位置
    }
  },
  computed: {
    ...mapState('book', [
      'isMobile', // 是否移动端
      'pages' // 页码列表，元素为每页的图片url
    ]),
    longPress() {
      return this.$store.state.config.bookObj.longPress
    },
    ...mapGetters('book', [
      'pagesForPc' // pc端专用页码列表，处理了两页合并
    ])
  },
  methods: {
    // 关闭本组件
    closeMe() {
      this.visible = false
    },
    init() {
      this.closeMe()
      this.curTranslateX = 0
    },
    // 切换页码，翻书
    choosePage(val) {
      this.curPageIndex = val
      this.pageMessage = val + 1
      this.toPage('enter') // turnBookMixin 中的，用于翻书
      this.visible = false
    },
    // 切换页码，翻书 for pc
    choosePagePc({ name }) {
      this.pageMessage = name.split('-')[0]
      this.toPage('enter') // turnBookMixin 中的，用于翻书
    },
    // 左右切换翻页
    toLeftRightPage(direction) {
      const distance = $('.innerScroll')
        .width()
        .toFixed(1)
      const scrollWidth = document.querySelector('.innerScroll').scrollWidth.toFixed(1)
      let target
      switch (direction) {
        case 'left': {
          target = (+this.curTranslateX + +distance).toFixed(1)
          // 最大为0
          if (target > 1e-3) return
          break
        }
        case 'right': {
          target = (+this.curTranslateX - +distance).toFixed(1)
          // 最小为 scrollWidth * -1
          if (target <= scrollWidth * -1) return
          break
        }
        default:
          break
      }
      // console.log(distance, scrollWidth, target, this.curTranslateX)
      this.curTranslateX = target
    }
  },
  watch: {
    // turnBookMixin 中的当前页码
    splitCurrentPage(val) {
      this.curPageIndex = +val - 1
    }
  },
  created() {
    // 改变窗口尺寸时关闭本组件
    window.addEventListener('resize', this.init)
  },
  destroyed() {
    window.removeEventListener('resize', this.init)
  }
}
</script>
<style lang="scss" scoped>
// pc端解决从最底部弹起问题，对移动端无影响
.el-drawer__wrapper {
  bottom: 40px !important;
}
</style>
<style lang="scss">
.thumbWrap {
  background: #272727 !important;
  opacity: 0.95;
  // pc端
  .drawerWrap {
    display: flex;
    align-items: center;
    height: 100%;
    .pager {
      min-width: 2.7vw;
      height: 6.9vw;
      background: center/1.4vw no-repeat #050505;
      cursor: pointer;
      &.pagerLeft {
        background-image: url('../../../assets/imgs/thumbnailRB.png');
      }
      &.pagerRight {
        background-image: url('../../../assets/imgs/thumbnailLB.png');
      }
    }
    .close {
      position: absolute;
      height: 1.4vw;
      width: 1.4vw;
      background: center/1.4vw no-repeat url('../../../assets/imgs/close_searResult.png');
      top: 0.7vw;
      right: 0.7vw;
      cursor: pointer;
    }
    .content {
      margin: 0 2.3vw;
      overflow: hidden;
      width: 100%;
      .innerScroll {
        width: 100%;
        display: flex;
        // transition: transform 0.2s; // 动画效果暂时去掉
      }
      .contentItem {
        cursor: pointer;
        margin-right: 2.2vw;
        .itemImage {
          width: 15.4vw;
          height: 11.1vw;
          padding: 0.2vw;
          box-sizing: content-box;
          img {
            width: 50%;
            height: 100%;
          }
          &.single {
            width: 7.5vw;
            img {
              width: 100%;
            }
          }
        }
        &.active,
        &:hover {
          .itemImage {
            border: 0.2vw solid #df5813;
            padding: 0;
          }
        }
        .itemName {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          margin-top: 0.1vw;
        }
      }
    }
  }
  // 移动端
  .mobileWrap {
    .mobileTitle {
      font-size: 3.7vw;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #ffffff;
      margin-top: 2.7vw;
      display: flex;
      align-items: center;
      .mobileTitleText {
        text-align: center;
        width: 100%;
      }
      .mobileClose {
        height: 7.2vw;
        width: 7.2vw;
        background: center/7.2vw no-repeat url('../../../assets/imgs/close-quick-switch.png');
        cursor: pointer;
        margin-right: 1.6vw;
      }
    }
    .mobileContent {
      margin: 5.3vw 4vw;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      .pageWrap {
        width: 28.8vw;
        height: 46.1vw;
        margin-top: 4vw;
        &:not(:nth-child(3n)) {
          margin-right: 2.8vw;
        }
        .image {
          height: 40.3vw;
          margin: 0.8vw;
          margin-bottom: 0.5vw;
          position: relative;
          .img-shar {
            position: absolute;
            z-index: 100;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            opacity: 0;
          }
          img {
            height: 38.7vw;
            width: 27.2vw;
          }
        }
        &.active {
          .image {
            border: 0.8vw solid #df5813;
            margin: 0;
            margin-bottom: 1.3vw;
          }
        }
        .name {
          font-size: 3.7vw;
          line-height: 5.3vw;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
.no-touch {
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  vertical-align: sub;
  display: block;
}
</style>
